module.exports = __webpack_public_path__ + "static/media/general manager smart final icon.0f92c599.svg";